/** An object containing URL paths for different pages of the app, to reduce the use of hardcoded strings. */
export const URLPaths = {
  admin: "/admin",
  edDepInfo: "/education-department-info",
  edDepInfoAdmin: "/education-department-info-admin",
  edDepSettings: "/education-department-settings",
  edDepWebsite: "https://hope.edu/academics/education/",
  edFacultyStaff: "https://hope.edu/academics/education/faculty-staff.html",
  hopeTeachersInTheWorld: "/hope-teachers-in-the-world",
  jobOpeningsFinder: "/education-job-openings",
  logout: "/logout",
  map: "/map",
  mapViewAdmin: "/map-view-admin",
  mayTerms: "/may-terms",
  offCampusFinder: "/study-abroad",
  partnerSchools: "/partner-schools",
  pictureWall: "/picture-wall",
  poll: "/poll",
  searchPage: "/search-page",
  studentTeachers: "/student-teachers",
};
